import {getOnboardedCountriesService} from '@/services/marketsService'
import {OnboardedCountry} from '@/types/Markets'

export async function getOnboardedCountriesUseCase(signal?: AbortSignal): Promise<OnboardedCountry[]> {
  const response = await getOnboardedCountriesService(signal)
  return response.content
}
